import { isCursorAtEnd, isCursorAtStart } from './functions.js';


export default class TableArrowNavElement extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        TableArrowNavModule(this);
    }
};

function TableArrowNavModule(element, args) {
	let inputSelectors = 'input[type=text], input[type=email], input[type=number], input[type=checkbox], input[type=radio], select, textarea, .selectize-control';

	element.addEventListener('keydown', function(event) {
		if (!event.target.matches(inputSelectors)) {
			return;
		}
		if (event.key === 'ArrowRight') {
			onArrowRight(event);
		} 
		else if (event.key === 'ArrowLeft') {
			onArrowLeft(event);
		} 
		else if (event.key === 'ArrowDown') {
			onArrowDown(event);
		} 
		else if (event.key === 'ArrowUp') {
			onArrowUp(event);
		}

	});

	let onArrowUp = function(event) {
		let tableCell = event.target.closest('td');
		let tableRow = tableCell.closest('tr');
		let tdIndex = Array.from(tableRow.children).indexOf(tableCell);

		let targetTableRow = tableRow.previousElementSibling;

		if (!targetTableRow) {
			return;
		}

		let targetTableCell = Array.from(targetTableRow.children).find((cell, index) => index === tdIndex);

		if (!targetTableCell) {
			return;
		}
		
		focusNextInput(targetTableCell);

	}

	let onArrowDown = function(event) {
		let tableCell = event.target.closest('td');
		let tableRow = tableCell.closest('tr');
		let tdIndex = Array.from(tableRow.children).indexOf(tableCell);

		let targetTableRow = tableRow.nextElementSibling;

		if (!targetTableRow) {
			return;
		}

		let targetTableCell = Array.from(targetTableRow.children).find((cell, index) => index === tdIndex);

		if (!targetTableCell) {
			return;
		}
		
		focusNextInput(targetTableCell);

	}

	let onArrowRight = function(event) {
		let tableCell = event.target.closest('td');

		let targetTableCell = tableCell.nextElementSibling;

		if (!targetTableCell) {
			return;
		}

		if (event.target.nodeName === 'INPUT' && allowLateralMove(event.target) && isCursorAtEnd(event.target)) {
			focusNextInput(targetTableCell);
		}
	}
	
	let onArrowLeft = function(event) {
		let tableCell = event.target.closest('td');

		let targetTableCell = tableCell.previousElementSibling;

		if (!targetTableCell) {
			return;
		}

		console.log('cha', isCursorAtStart(event.target));
		if (event.target.nodeName === 'INPUT' && allowLateralMove(event.target) && isCursorAtStart(event.target)) {
			focusNextInput(targetTableCell);
		}
	}

	let allowLateralMove = function(element) {
		return ['text', 'number', 'email'].indexOf(element.type) !== -1;
	}

	let focusNextInput = function(targetTableCell) {
		let targetInput = targetTableCell.querySelector(inputSelectors);

		if (targetInput.matches('select.selectized')) {
			targetInput.selectize.focus();
		} else {
			targetInput.focus();
		}

	}
	
}

window.customElements.define('table-arrow-nav', TableArrowNavElement);